import React from 'react';
import { useEnergyMarketPriceContext } from 'components/MarketEnergyTariffs/Context';
import { Message } from 'semantic';
import { useTranslation } from 'react-i18next';
import { Layout } from 'components/Layout';
import MarketEnergyTariffsModal from 'components/MarketEnergyTariffs/Modal';

export default function CurrentMarketPrices() {
  const { t } = useTranslation();
  const context = useEnergyMarketPriceContext();

  if (context.loading) {
    return null;
  }

  if (!context.activeTariff) {
    return (
      <Message
        error
        content={
          <>
            {t(
              'advancedTariff.noMarketPrices',
              'Current market prices are not available.'
            )}
          </>
        }
      />
    );
  }

  return (
    <>
      <Message
        style={{ marginBottom: '0' }}
        info
        content={
          <Layout spread horizontal top>
            <div style={{ color: '#045488' }}>
              <div style={{ marginBottom: '0.4em' }}>
                {t(
                  'advancedTariff.energyMarketPrice',
                  'Energy Market Price on {{date}}, {{timeFrom}} - {{timeTo}}',
                  {
                    date: context.currentTariffFormatted?.date,
                    timeFrom: context.currentTariffFormatted?.startTime,
                    timeTo: context.currentTariffFormatted?.endTime,
                  }
                )}
              </div>
              <div>
                {context.currentTariffFormatted?.price}{' '}
                {t('advancedTariff.perKwh', 'per kWh')}
              </div>
            </div>

            <MarketEnergyTariffsModal />
          </Layout>
        }
      />
      <div
        style={{
          fontSize: '14px',
          marginTop: '8px',
          fontStyle: 'italic',
          marginBottom: '8px',
        }}>
        {t(
          'advancedTariff.energyMarketPriceDisclaimer',
          'Market Prices are only available in the Netherlands.'
        )}
      </div>
    </>
  );
}
